export default {
  newDesign: true,
  title: "Çocugunuzu mutlu ve özgüvenli yetistiriyor musunuz? | Kodland",
  downtimeUrl: "http://kodland.org/tr",
  parameters: {
    landing_id: "TrQuPaPaid",
    segment: 11,
  },
  startPage: {
    title:
      "3 dakikalık testi çözün ve ebeveynlik yöntemlerinin eski ve yanlış inanışlara dayanıp dayanmadığını öğrenin!",
    subtitle:
      "✔️ Eğitim uzmanları tarafından hazırlandı<br>❤️ Tamamen ücretsiz<br>🎁 Testin sonunda farkındalıklı ebeveynlik rehberi hediye<br>👪 100.000'den fazla ebeveyn bize güveniyor",
    image: {
      url: "/welcome/tr_content_myths_paid_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/tr_content_myths_paid_mob2.png",
      style: {
        width: "100%",
      },
    },
    button: " Hemen başlayın! 🚀 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Çocukları dövmek tabii ki kötü. Ama küçük tokatlar ve enselere vurmak kimseye zarar vermez",
      answers: [
        "🤔 Sanırım",
        "🙂 Beni de dövdüler, normal büyüdüm",
        "😳 Şiddet asla kabul edilemez!",
      ],
    },
    2: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/tr_content_myths_paid_img1.png",
      subtitle:
        "2016 yılında bilim insanları, 160.927 çocuğun dahil olduğu bir meta-analiz gerçekleştirdi. Sonuç net: Fiziksel cezalar, 'masum tokatlar' bile olsa, çocuklar üzerinde olumsuz etkilere sahiptir.",
      button: "Anladım!",
    },
    3: {
      question:
        "Çocuğun yanında üzülmek, ağlamak, hatalarını kabul etmek ve hatta zayıflık göstermek mümkündür",
      answers: [
        "😤 Hayır, otorite sarsılmamalı!",
        "🥺 Ben de insanım, bu normal",
      ],
    },
    4: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/q2_es.png",
      subtitle:
        "Eğer ebeveyn her zaman kendinden emin görünmeye çalışırsa, çocuk yetişkinleri gerçekçi olmayan bir şekilde algılar. Ayrıca, hatalarını kabul etmeyi ve çatışmaları çözmeyi öğrenemez. Fazla soğukkanlılık duygusal mesafe yaratabilir.",
      button: "Devam edelim",
    },
    5: {
      question:
        "Çocuktaki en önemli şeyler 3 yaşına kadar şekillenir, sonrası için ebeveynin rolü küçüktür",
      answers: [
        "😰 Ya doğruysa? Hataları düzeltemem!",
        "🥱 Öyleyse ben çoktan rahatladım",
        "🤨 Sanmıyorum, çocuklar sürekli gelişir!",
      ],
    },
    6: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/tr_content_myths_paid_img3.png",
      subtitle:
        "Her yaşta insanın gelişimini yönlendiren farklı bir ana etkinlik vardır. Çocuğun dengeli büyümesi ve her aşamada ebeveyn desteği alması çok önemlidir:",
      button: "Harika!",
    },
    7: {
      question:
        "Çocuğu tüm zorluklardan korumak en iyisidir, böylece çocukluğu gölgelenmez",
      answers: [
        "😇 Evet! Zorluklarla sonra tanışır",
        "😕 İmkansız, büyümek zaten zor",
        "😬 Zorluk eklemeli ki güçlü olsun!",
      ],
    },
    8: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/q4_es.png",
      subtitle:
        "Çocuk için travmatik olaylardan kaçınmak en iyisidir. Ancak onu her türlü zorluktan korumak, gerçekçi olmayan bir dünya algısı yaratır ve önemli deneyimlerden mahrum bırakır. Asıl önemli olan, zorluklarla baş ederken ona güvenli bir destek sunmaktır!",
      button: "Devam et",
    },
    9: {
      question: "Övgü çocuğa zarar verir",
      answers: ["🥺 Hayır, övgü önemli!", "🤐 Evet, yoksa hep onay bekler"],
    },
    10: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/tr_content_myths_paid_img5.png",
      subtitle:
        "Övgü tek başına kötü değildir! Ancak, hangi motivasyonla verildiği ve nasıl ifade edildiği çok önemlidir.",
      button: "Evet, bu önemli",
    },
    11: {
      question:
        "Çocuğunuzun çalışabileceği bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "☹️ Hayir",
          stopAnswer: true,
        },
      ],
    },
    12: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz.",
      type: "age",
      button: "",
    },
    13: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/fwd_freetc_latam_pic3_2.png",
      subtitle:
        "Harika, doğru yoldasınız! 🎉 Mutlu ve başarılı bir çocuk yetiştirmek için daha fazla yöntem öğrenmek ister misiniz? Size özel: Ücretsiz ebeveynlik rehberi + Kodlama deneme dersi!",
      button: "İlgileniyorum",
    },
    14: {
      title: "Formu doldurun ve ders tarihini seçin",
      typeInfo: "congrats",
      subtitle:
        "Kodland uzmanlarının hazırladığı ücretsiz rehberi alın ve çocuğunuz için ücretsiz kodlama deneme dersine katılın.",
      button: "Hadi başlayalım!",
    },
    15: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    16: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    17: {
      title: "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    18: {
      title:
        "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    19: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    },
  },
};
